import {applyMiddleware, combineReducers, createStore, Reducer, Store, StoreEnhancer} from "redux";
import promiseMiddleware from "redux-promise";
import {persistReducer, persistStore} from "redux-persist";
import storage from "redux-persist/lib/storage";
import defaultStore, {IStore} from "./defaultStore";
import metaReducer from "./meta/metaReducer";
import authReducer from "./auth/authReducer";
import logger from "redux-logger";

const metaPersistConfig = {
	key: "meta",
	storage,
	whitelist: ["currentUser"],
};

const authPersistConfig = {
	key: "auth",
	storage,
	whitelist: ["fullToken"],
};

const reducers: Reducer<any, any> = combineReducers({
	metaStore: persistReducer(metaPersistConfig, metaReducer),
	authStore: persistReducer(authPersistConfig, authReducer)
});

const middleware: StoreEnhancer = applyMiddleware(
	// logger,
	promiseMiddleware,
);

export const store: Store<IStore> = createStore(reducers, defaultStore, middleware);
export const persistor = persistStore(store);
